import { markersDataSelector } from '@/redux/markers/markers.selectors';
import { store } from '@/redux/store';
import type { Marker } from 'minerva-plugin-api';

export const getAllMarkers = (): Marker[] => {
  const { getState } = store;
  const markers = markersDataSelector(getState());

  return markers;
};
